export enum LevelRequirementStatus {
  Incomplete = 'incomplete',
  InProgress = 'in-progress',
  Complete = 'complete',
  Locked = 'locked',
  NotApplicable = 'not-applicable',
}
